import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { PAGE_BREAKPOINTS } from '../../../../../../constants/commonConstants';
import { useBreakpoint } from '../../../../../../hooks';
import cx from 'classnames';
import { v4 as uuid } from 'uuid';
export const ComponentLoader = ({ classname }) => {
    const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
    const loaderCount = !isMD ? [...Array(4)] : [...Array(6)];
    return (_jsxs("div", { className: cx(classname, 'w-100'), children: [_jsx("div", { className: "mb-4", children: _jsx(CatSkeleton, { width: "305px" }) }), loaderCount.map((_value) => {
                return (_jsx("div", { className: "mb-2 w-100", children: _jsx(CatSkeleton, { size: "lg" }) }, uuid()));
            })] }));
};
export default ComponentLoader;
